import { render } from "./CreateDeliverable.vue?vue&type=template&id=8223eda2&scoped=true"
import script from "./CreateDeliverable.vue?vue&type=script&lang=js"
export * from "./CreateDeliverable.vue?vue&type=script&lang=js"

import "./CreateDeliverable.vue?vue&type=style&index=0&id=8223eda2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8223eda2"]])

export default __exports__